import { PUBLIC_URL } from '../../utils/constants';

export default {
  HR_PAGE: `${PUBLIC_URL}/hr`,
};
